import { z } from "../wire/zod";

export const randomDataResponseSchema = z.object({
  timestampIn: z.number(),
  timestampOut: z.number(),
  data: z.string(),
});
